import React from "react";
import MuiAdd from "@mui/icons-material/Add";
export const AddIcon = (props) => {
    const { style, ...rest } = props;
    return React.createElement(MuiAdd, { style: { transform: "scale(1.2)", ...style }, ...rest });
};
